(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/extra-game-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/extra-game-info.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useContext,
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const formatCurrency = svs.utils.format.Currency;
const {
  getLocalizedWeekday,
  FormatTime: formatTime
} = svs.utils.date;
const {
  productMapping,
  rules
} = svs.numbergames;
const {
  drawsApi
} = svs.numbergames.draws;
const {
  containerStates
} = svs.numbergames.fractiongames.constants;
const {
  CampaignInfo
} = svs.numbergames.fractiongames.components.gamecard;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const ExtraGameInfo = () => {
  const {
    selectors
  } = useContext(ContainerContext);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const game = useSelector(selectors.selectGame);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const sharePrice = useSelector(selectors.selectSharePrice);
  const totalPrice = useSelector(selectors.selectTotalPrice);
  const totalShares = useSelector(selectors.selectTotalShares);
  const containerState = useSelector(selectors.selectContainerState);
  const gameInfo = useMemo(() => {
    const Kopstopp = 'Köpstopp';
    const NastaKopstopp = 'Nästa köpstopp';
    const currentRegCloseTime = drawsApi.currentRegCloseTime(productNumeric);
    const nextRegCloseTime = drawsApi.nextRegCloseTime(productNumeric);
    const systemDescription = () => {
      var _game$systemSize, _game$systemSize2;
      return rules.system.systemName({
        numbersLength: (_game$systemSize = game.systemSize) === null || _game$systemSize === void 0 ? void 0 : _game$systemSize.numbersSize,
        numbersExtraLength: (_game$systemSize2 = game.systemSize) === null || _game$systemSize2 === void 0 ? void 0 : _game$systemSize2.extraNumbersSize,
        level: game.level
      });
    };
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      [game.isSystemBoard ? systemDescription() : 'Antal rader']: "".concat(game.rowCount, " rader")
    }, productMapping.isKeno(productNumeric) && {
      'Kung Keno': game.hasKungKeno ? "".concat(formatCurrency(game.rowPrice * game.rowPriceMulti), " kr/rad") : 'Nej'
    }), productMapping.hasJoker(productNumeric) && {
      Joker: game.jokerPrice ? "".concat(formatCurrency(game.jokerPrice), " kr") : 'Nej'
    }), {}, {
      'Pris totalt': "".concat(formatCurrency(totalPrice), " kr"),
      'Antal andelar': "".concat(totalShares, " st"),
      'Pris per andel': "".concat(formatCurrency(sharePrice), " kr")
    }, containerState === containerStates.CONTAINER_OPEN && {
      [Kopstopp]: buyinCloseTime ? "".concat(getLocalizedWeekday(buyinCloseTime), " kl. ").concat(formatTime('HH:mm', buyinCloseTime)) : ''
    }), containerState === containerStates.GAME_SOLD_OUT && {
      [Kopstopp]: currentRegCloseTime ? getLocalizedWeekday(currentRegCloseTime) : ''
    }), containerState === containerStates.CONTAINER_CLOSED && {
      [NastaKopstopp]: nextRegCloseTime ? getLocalizedWeekday(nextRegCloseTime) : ''
    }), productMapping.isDaySpecificId(productNumeric) && {
      Dragningsdag: productMapping.getDay(productNumeric)
    });
  }, [containerState, buyinCloseTime, game, productNumeric, sharePrice, totalPrice, totalShares]);
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "ng-fg-row-info"
  }, game.isSystemBoard ? 'Raderna skapas via ett systemspel där numren slumpas. Antalet nummer avgör systemets storlek och antal rader.' : 'Alla rader skapas individuellt med slumpade nummer.'), productMapping.isLotto(productNumeric) && React.createElement("p", {
    className: "ng-fg-lotto-row-info"
  }, "Lotto 1 & 2 med Joker"), React.createElement(CampaignInfo, null), React.createElement("div", {
    className: "ng-fg-card-extra-info"
  }, React.createElement("hr", {
    className: "ng-fg-hr margin-top-0"
  }), Object.entries(gameInfo).map(_ref => {
    let [key, value] = _ref;
    return React.createElement("p", {
      key: key
    }, React.createElement("span", null, key, ": "), " ", value);
  }), React.createElement("hr", {
    className: "ng-fg-hr"
  }), React.createElement("p", {
    className: "fg-extra-info-game-closed"
  }, "Om inte alla andelar s\xE5lts vid k\xF6pstopp f\xF6rs pengarna tillbaka till ditt spelkonto d\xE5 spelet annulleras.")));
};
svs.numbergames.fractiongames.components.gamecard.ExtraGameInfo = ExtraGameInfo;

 })(window);